import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Layout } from 'antd';
import { Paper } from '@material-ui/core';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import PageTitle from '../../../common/components/PageTitle';
import { NotFound } from '../../App/components/NotFound';
import TableFilters from './components/TableFilters';
import TableTabs from './components/TableTabs';
import LeadsTable from './components/LeadsTable';
import { VIEW_PAYMENT_APPROVAL_URL, VIEW_LEAD_PROFILE_URL } from './constants';

const urls = [VIEW_PAYMENT_APPROVAL_URL, VIEW_LEAD_PROFILE_URL];

class Index extends Component {
    render() {
        const { views_permissions } = this.props;
        const pageAccess = views_permissions[VIEW_PAYMENT_APPROVAL_URL];
        const leadProfileAccess = views_permissions[VIEW_LEAD_PROFILE_URL];

        if (!pageAccess) {
            return <NotFound />;
        }

        return (
            <Layout>
                <Row>
                    <Col span={24}>
                        <PageTitle
                            title="Leads Payments Approval"
                            subhead="Detailed information about Leads payments waiting approval"
                        />
                    </Col>
                </Row>
                <Row style={{ marginBottom: 5 }}>
                    <Col span={24}>
                        <TableFilters />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <Paper>
                            <TableTabs />
                            <LeadsTable leadProfileAccess={leadProfileAccess} />
                        </Paper>
                    </Col>
                </Row>
            </Layout>
        );
    }
}

const mapStateToProps = (state) => ({
    views_permissions: state.App.Permissions.views_permissions,
});

export default connect(mapStateToProps)(checkPermissionsHOC(Index, urls));



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/index.js